import { isNil } from 'lodash-es';
import { TrackerType } from '../api/trackers/tracker.contracts';
import { TFunction } from 'i18next';

export function trackerTypeToString(type: TrackerType | undefined, t: TFunction) {
  if (isNil(type)) {
    return '';
  }
  switch (type) {
    case TrackerType.Barcode:
      return t('barcode');

    case TrackerType.RFID:
      return t('rfid');

    case TrackerType.Sigfox:
      return t('sigfox');

    case TrackerType.BLE:
      return t('ble');
    case TrackerType.LTE:
      return t('lte');
    default:
      return '';
  }
}

export function trackerUniqueIdentifier(
  tracker: {
    type: TrackerType;
    epc?: string | null;
    barcode?: string | null;
    deviceId?: string | null;
  },
  t: TFunction,
) {
  const unknownTracker = t('tracker_unknown');
  switch (tracker.type) {
    case TrackerType.Barcode:
      return tracker.barcode ? tracker.barcode : unknownTracker;

    case TrackerType.RFID:
      return tracker.epc ? tracker.epc : unknownTracker;

    case TrackerType.Sigfox:
    case TrackerType.BLE:
    case TrackerType.LTE:
      return tracker.deviceId ? tracker.deviceId : unknownTracker;

    default:
      return unknownTracker;
  }
}
